var map = {
	"./choose-up-11_1 virtual_text.png": "4da3",
	"./choose-up-11_1_text.png": "9598",
	"./choose-up-12_2 virtual_text.png": "c5da",
	"./choose-up-12_2_text.png": "c923",
	"./choose-up-12_3 virtual_text.png": "56b4",
	"./choose-up-12_3_text.png": "26fa",
	"./choose-up-13_4 virtual_text.png": "e75c",
	"./choose-up-13_4_text.png": "251c",
	"./choose-up-1_1_text.png": "f962",
	"./choose-up-2_2_text.png": "6b22"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d088";